import {Component} from '@angular/core';
import {TabsPageContainer} from "../../uiComponents/tabsPageContainer";

@Component({
  selector: 'app-collaboration-protection-tabs',
  templateUrl: './collaboration-protection-tabs.component.html'
})
export class CollaborationProtectionTabsComponent extends TabsPageContainer {
	tabWidth = 150;
	activeRouteComponent: any;

	onRouteActivate(component: any) {
		this.activeRouteComponent = component;
	}

	get isConfigTab(): boolean {
		return !!(this.activeRouteComponent && this.activeRouteComponent.isThisFeatureSupported !== undefined);
	}

	get isFeatureSupported(): boolean {
		// If the active component has isThisFeatureSupported (config tab), use it.
		// Other tabs (reviewers, users, etc.) only render when the feature is already supported.
		if (this.isConfigTab) {
			return this.activeRouteComponent.isThisFeatureSupported === true;
		}
		return true;
	}
}
